module.exports = __webpack_public_path__ + "static/img/rank_45.f97573c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_45.png
// module id = 0C7J
// module chunks = 0